module.exports = __webpack_public_path__ + "static/media/1012713.999983e4.jpg";